import { Drawer } from "antd";
import { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";
import { ROUTES, SCREENS } from "../../constants";
import { useWidth } from "../../hooks/useWidth";
import { logOut } from "../../redux/auth/authThunk";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import YudlButton from "../Button";
import Menu from "../Icons/Menu";
import { AuthDropdown } from "./AuthDropdown";
import "./style.css";

type NavLinkObj = {
    path: string;
    title: string;
    type: string;
    icon?: JSX.Element;
    classname?: string;
    variant?: "primary" | "secondary" | "secondary-light" | "outline-primary";
    mobileVariant?: "primary" | "secondary" | "secondary-light" | "outline-primary";
    usemobileVariant?: boolean;
    usemobileType?: boolean;
    mobileType?: string;
};

const publicLinks: NavLinkObj[] = [
    { path: ROUTES.ABOUTUS, title: "About us", type: "regular" },
    { path: ROUTES.PORTFOLIO, title: "Portfolio", type: "regular" },
    { path: "/#how-it-works", title: "How it works", type: "anchor", classname: "me-3" },
    {
        path: ROUTES.LOGIN,
        title: "Login",
        type: "link",
        classname: "ms-3",
        variant: "secondary-light",
    },
];

const privateLinks: NavLinkObj[] = [
    {
        path: ROUTES.DASHBOARD,
        title: "Dashboard",
        type: "regular",
        mobileType: "link",
        usemobileVariant: true,
        mobileVariant: "primary",
    },
    { path: ROUTES.PROFILE, title: "Profile", type: "regular" },
];

const Navbar = () => {
    const [showMenu, setShowMenu] = useState(false);
    const { width } = useWidth();

    const isMobile = width < SCREENS.MOBILE;

    const size = width >= 768 ? 500 : 300;

    const { isAuth } = useAppSelector(state => state.auth);

    const links = isAuth ? privateLinks : publicLinks;

    const dispatch = useAppDispatch();

    return (
        <Fragment>
            <nav className="navbar fixed-top yudl-topnav">
                <div className="container-lg container-fluid d-flex justify-content-between align-items-center">
                    <NavLink to={"/"}>
                        <img src="/logo.png" alt="YUDL" height={isMobile ? 35 : "auto"} />
                    </NavLink>
                    {!isMobile && (
                        <div className="yudl-topnav-links-container d-flex align-items-center">
                            {links.map((link, i) =>
                                ["link", "anchor"].includes(link.type) ? (
                                    <YudlButton
                                        className={link.classname}
                                        key={i}
                                        buttonRole={link.type as any}
                                        link={link.path}
                                        variant={
                                            !link?.usemobileVariant
                                                ? link?.variant
                                                : isMobile
                                                ? link.mobileVariant
                                                : link.variant
                                        }
                                        children={
                                            <>
                                                {link.icon} <span className="ms-1">{link.title}</span>
                                            </>
                                        }
                                    />
                                ) : (
                                    <NavLink
                                        key={i}
                                        to={link.path}
                                        className={`yudl-topnav-links ${link.type}-link me-5`}
                                    >
                                        {link.title}
                                    </NavLink>
                                )
                            )}
                            {isAuth && <AuthDropdown />}
                        </div>
                    )}
                    {isMobile && <Menu onClick={() => setShowMenu(prev => !prev)} />}
                </div>
            </nav>
            <Drawer placement={"right"} width={size} onClose={() => setShowMenu(false)} visible={showMenu && isMobile}>
                <div className="d-flex justify-content-center text-align-center flex-column px-2">
                    {!isAuth && (
                        <NavLink
                            onClick={() => setShowMenu(false)}
                            to={"/"}
                            className={`yudl-topnav-links regular-link my-3`}
                        >
                            Home
                        </NavLink>
                    )}
                    {links.map((link, i) =>
                        ["link", "anchor"].includes(link.type) ||
                        ["link", "anchor"].includes(link?.mobileType as string) ? (
                            <YudlButton
                                onClick={() => setShowMenu(false)}
                                key={i}
                                link={link.path}
                                className="my-3"
                                buttonRole="link"
                                variant={link?.variant}
                                children={
                                    <>
                                        {link.icon} <span className="ms-1">{link.title}</span>
                                    </>
                                }
                            />
                        ) : (
                            <NavLink
                                onClick={() => setShowMenu(false)}
                                key={i}
                                to={link.path}
                                className={`yudl-topnav-links ${link.type}-link my-3`}
                            >
                                {link.title}
                            </NavLink>
                        )
                    )}
                    {isAuth && (
                        <div className="text-danger cursor-pointer text-center mt-2" onClick={() => dispatch(logOut())}>
                            Logout
                        </div>
                    )}
                </div>
            </Drawer>
        </Fragment>
    );
};

export default Navbar;
